// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import ShopTaxPoliciesInternal from './discovery/shops/shop_tax_policies_internal';
import { RCAccordion } from '@reverbdotcom/cadence/components';
import { Item2ShopTaxPoliciesData } from '@reverbdotcom/commons/src/gql/graphql';

interface Props {
  listing: Item2ShopTaxPoliciesData.Fragment;
}

export const Item2ShopTaxPoliciesFragment = gql`
  fragment Item2ShopTaxPoliciesData on Listing {
    _id
    taxPolicies {
      displayRate
      displayLocation
      policyType
    }
  }
`;

export default function Item2ShopTaxPolicies({ listing }: Props) {
  return (
    <div
      className="bdb-1 bd-primary"
    >
      <RCAccordion
        heading={I18n.t('discovery.shopTaxPolicies.taxPolicies')}
        size="small"
        id="shop-tax-policies"
      >
        <ShopTaxPoliciesInternal taxPolicies={listing.taxPolicies} />
      </RCAccordion>
    </div>
  );
}
